angular.module('impactx.catalog').controller('CatalogRuleCheckCheckedOutListCtrl',
    CatalogRuleCheckCheckedOutListCtrl);

CatalogRuleCheckCheckedOutListCtrl.$inject = ['$scope', '$routeParams', 'selectedListItems', 'CatalogRuleService'];

function CatalogRuleCheckCheckedOutListCtrl($scope, $routeParams, selectedListItems, CatalogRuleService)
{
    var self = this;
    this.runRuleCheck = function(event, trns)
    {
        CatalogRuleService.runRuleCheck($routeParams.catId, trns.ruleCheckStarted);
        $scope.$$childHead.data.actions.runRuleCheck.allowed = false;
    };

    this.getPrintToken = function() {
        return selectedListItems.getFirstSelectedItem().printTokens.protocol;
    };

    this.getDetailsLink = function()
    {
        if (selectedListItems.getFirstSelectedItem())
        {
            return "catalogrulecheckcheckedoutitemlist/" + selectedListItems.getFirstSelectedId() + "/" + $routeParams.catId
        }
    };

    this.canRunRuleCheck = function()
    {
        return selectedListItems.isNoSelection() && impactX.isDefined($scope, '$$childHead.data.actions.runRuleCheck.allowed'); // not the best but it works here
    };


    var buttonDefinition = [
        {
            label: "printProtocol",
            type: 'print',
            condition: selectedListItems.isSingleSelection,
            process: 'CatalogRule',
            params: {
                printTokenFunction: self.getPrintToken
            }
        },
        {label: "details", linkFunction: self.getDetailsLink, type:'link', condition: selectedListItems.isSingleSelection, process: 'CatalogRule'},
        {label: "runRuleCheck", action: self.runRuleCheck, condition: self.canRunRuleCheck, process: 'CatalogRule'}
    ];
    this.meta = {
        rowTemplate: 'modules/catalog/templates/catalogrulechecklist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/catalog/rulechecklist',
        id: "catalogrulecheckcheckedoutlist",
        params: {'catId': $routeParams.catId},
        catId: $routeParams.catId,
        excelExport: true,
        valuesInteger: [{name: 'CatId', value: $routeParams.catId}],
        buttonDefinition: buttonDefinition
    };
    this.getMeta = function () {
        return this.meta;
    }
}